// msgbox.ts ↔ game/misc.cpp:471-560 — HtMessageBox: the Hostile-Takeover-style modal
// message box. The canvas DialogForm (CreateHtMessageBox over the kidfMessageBox forms.ini
// layout) was deleted in canvas-removal R2 — HtMessageBox now renders the DOM MessageBoxView.
//
// The C++ HtMessageBox blocks in DoModal and returns bool; here done(f) is the
// C++ return (the printf-variant formatting is the caller's template literal).

import type { ShellEnv } from './shellform.ts';

// game/res.h:26, 319
export const kidfMessageBox = 1029;
export const kidfMessageBoxQuery = 1058;

// game/ht.h:8536-8538
export const kfMbWhiteBorder = 0x0001;
export const kfMbKeepTimersEnabled = 0x0004;

/** The C++ globals this reaches: gtimm. `domMessageBox` is the message-box seam
 *  (shellform.ts) — HtMessageBox renders the DOM MessageBoxView (it replaced the canvas
 *  DialogForm); the result routes through the SAME `done` callback, so every HtMessageBox
 *  call site (resign/observe/MP errors) stays wire-identical.
 *  NOTE: the in-game LAG ALERT does NOT route through THIS (modal, done()-callback) seam —
 *  it is modeless + GetResult()-polled, so Phase 5 gave it its OWN dedicated DOM seam
 *  (env.domLagBox) via CreateLagForm/DomLagForm (ui/lagform.ts). Both render the SAME DOM
 *  MessageBoxView (the lag box passes modeless:true to suppress backdrop/Esc dismiss). */
export type MsgBoxEnv = Pick<ShellEnv, 'gtimm' | 'domMessageBox'>;

// game/misc.cpp:471-480 (the vsprintf overload collapses: callers format) +
// game/misc.cpp:482-500 — HtMessageBox(idf, wf, title, body)
export function HtMessageBox(
  env: MsgBoxEnv,
  wf: number,
  pszTitle: string,
  pszBody: string,
  done: ((f: boolean) => void) | null = null,
  idf: number = kidfMessageBox,
): void {
  // render the DOM MessageBoxView. The timer-gate + done(f) are wire-safe — only
  // the presentation changes; the choice routes through the SAME `done` callback.
  if (env.domMessageBox !== undefined) {
    if (!(wf & kfMbKeepTimersEnabled)) env.gtimm.Enable(false);
    const variant = idf === kidfMessageBoxQuery ? 'query' : 'ok';
    env.domMessageBox(pszTitle, pszBody, variant, (wf & kfMbWhiteBorder) !== 0, (f) => {
      if (!(wf & kfMbKeepTimersEnabled)) env.gtimm.Enable(true);
      if (done !== null) done(f);
    });
    return;
  }

  // No DOM message-box seam wired (e.g. a headless harness) — resolve negatively.
  if (done !== null) done(false);
}
